/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {CercaFormComponent} from "./cerca-form/cerca-form.component";
import {editRoute, newRoute} from "../../shared/services/data.service";
import {CercaListComponent} from "./cerca-list/cerca-list.component";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class CercaRoutingModule {}

export const cercaRoutes: any[] = [
    {
        path: '',
        component: CercaListComponent
    },{
        path: editRoute + '/:id',
        component: CercaFormComponent
    },{
        path: newRoute,
        component: CercaFormComponent
    }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/cercas/cercas-routing.module.ts
 **/